import type { DriverApi } from '@/pages/Business/pages/Drivers/models';
import { CircularProgress, RadioGroup } from '@mui/material';
import DriverItem from './DriverItem';

export interface DriverListWithPhotoProps {
  loading: boolean;
  error: boolean;
  drivers: DriverApi[];
  selectedId: string | null;
  onSelect: (driverId: string) => void;
}

const DriverListWithPhoto = ({
  loading,
  error,
  drivers,
  selectedId,
  onSelect,
}: DriverListWithPhotoProps) => {
  if (loading) {
    return (
      <div className='flex justify-center items-center py-8'>
        <CircularProgress size={32} />
      </div>
    );
  }

  if (error) {
    return (
      <div className='text-center text-gray-600 py-6'>
        Error al cargar conductores. Intente de nuevo.
      </div>
    );
  }

  if (drivers.length === 0) {
    return (
      <div className='text-center text-gray-600 py-6'>
        No se encontraron conductores.
      </div>
    );
  }

  return (
    <RadioGroup value={selectedId ?? ''} sx={{ flexWrap: 'nowrap' }} className='flex flex-col overflow-y-auto overflow-x-hidden max-h-[400px] pr-1'>
      {drivers.map((driver) => (
        <DriverItem
          key={driver.id}
          driver={driver}
          selected={selectedId === driver.id}
          onSelect={onSelect}
        />
      ))}
    </RadioGroup>
  );
};

export default DriverListWithPhoto;
